import React from "react";
import { Message } from "components/Atoms/Message";
import { formatLongDate } from "utilities";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
  nextBillingCycle: server.dto.BillingCycle
}

const NextIsFree = (props: Props) => <Message type="info">
  {RESX.Subscription.SwitchesToFreeOnX.replace("{0}", formatLongDate(props.activeSubscription.end))}
</Message>;

const NextIsAgainFree = () => (
  <Message type="info">{RESX.Subscription.ThisAccountIsForNonCommercialPurposes}</Message>);

const NextIsPaid = (props: Props) => <Message type="success">
  {RESX.Subscription.SwitchesToPaidOnX.replace("{0}", formatLongDate(props.activeSubscription.end))}
</Message>;

const NextIsReadOnly = (props: Props) => <Message type="error">
  {RESX.Subscription.SwitchesToReadOnlyOnX.replace("{0}", formatLongDate(props.activeSubscription.end))}
</Message>;

const NextIsAgainReadOnly = (props: Props) => (<>
  <table className="s1_table clean rowspace-small margin-bottom-large">
    <tbody>
      <tr>
        <td>{RESX.Subscription.Renewal}:</td>
        <td>{formatLongDate(props.activeSubscription.end)}</td>
      </tr>
    </tbody>
  </table>

  <Message type="info">
    {RESX.Subscription.YouCanReactivateAnyMoment}
  </Message>
</>);

const TermsRow = () => (<tr>
  <td>{RESX.Subscription.Terms}:</td>
  <td><a href={routes.content_LicenceTerms().absolute}>{RESX.Subscription.EndUserLicenceTerms}</a></td>
</tr>
);

interface NextIsCancelledProps extends Props {
  tip?: "readOnly"
}

const NextIsCancelled = (props: NextIsCancelledProps) => <Message type="error">

  <div className="margin-bottom-small">
    <strong>{RESX.Subscription.AccountClosesOnX.replace("{0}", formatLongDate(props.activeSubscription.end))}</strong>
  </div>

  {props.tip === "readOnly" && <div>
    {RESX.Subscription.ContactUsToChangeToReadOnly}
  </div>}
</Message>;

const NextIsTrialEnd = (props: Props) => {
  return <Message type="info" className="margin-bottom-larger">
    {
      props.activeSubscription.type === "trial" && <div className="margin-bottom-small">
        <strong>{RESX.Subscription.TrailEndsOnX.replace("{0}", formatLongDate(props.activeSubscription.end))}</strong>
      </div>
    }
    <div>
      {RESX.Subscription.ContactUsToActivateOrExtendTrial}
    </div >
  </Message>;
};

const NotImplementedSubscription = () => (<Message type="error">
  {RESX.Subscription.SomethingWentWrong}
</Message>);

export { NextIsAgainFree, NextIsAgainReadOnly, NextIsCancelled, NextIsFree, NextIsPaid, NextIsReadOnly, NextIsTrialEnd, NotImplementedSubscription, TermsRow };

